module.exports = __webpack_public_path__ + "static/media/a1.5b139424.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/a1.png
// module id = 43
// module chunks = 0